<template lang="html">
  <div
    v-if="groups.length"
    class="attributes-specs-list flex flex-col gap-4"
  >
    <section
      v-for="group in groups"
      :key="group.value"
      class="flex flex-col gap-1.5"
    >
      <h3 class="text-xs font-semibold tracking-wide text-muted uppercase">
        {{ group.label }}
      </h3>

      <dl class="grid sm:grid-cols-2 sm:gap-x-10">
        <div
          v-for="attribute in group.attributes"
          :key="attribute.metadata.id"
          class="attributes-specs-list__row grid grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)] items-baseline gap-x-3 border-b border-default/60 py-1.5 text-sm"
        >
          <dt class="min-w-0 text-muted">
            <span class="line-clamp-2">
              {{ attribute.metadata.displayName }}
            </span>
          </dt>
          <dd
            class="min-w-0 text-right font-medium text-highlighted tabular-nums [&>div]:block [&>div>div:first-child]:hidden"
          >
            <AttributeDisplay :attribute="attribute" />
          </dd>
        </div>
      </dl>
    </section>
  </div>
</template>

<script setup lang="ts">
import type {
  ProductAttributeValueSlotDto,
  ProductDto,
} from '@repo/api/web/models'

import AttributeDisplay from './Attributes/AttributeDisplay.vue'

interface SpecsGroupItem {
  label: string
  value: string
  attributes: ProductAttributeValueSlotDto[]
}

const props = defineProps<{
  value: ProductDto
}>()

const wellKnownSystemNames = computed(() =>
  Object.keys(props.value.wellKnownAttributes || {}),
)

const variantKeyAttributeIds = computed(() =>
  Object.keys(props.value.variants?.keyWithValues || {}),
)

const groups = computed<SpecsGroupItem[]>(() => {
  if (!props.value.groups?.length) {
    return []
  }

  return props.value.groups
    .map((group) => {
      const attrs = group.attributes || []
      const filteredAttributes = attrs.filter(
        attr =>
          attr.metadata.isScalar
          && !wellKnownSystemNames.value.includes(
            attr.metadata.systemName || attr.metadata.displayName || '',
          )
          && !variantKeyAttributeIds.value.includes(String(attr.metadata.id)),
      )

      return {
        label: group.group?.displayName || 'Прочие атрибуты',
        value: String(group.group?.id || 'Общее'),
        attributes: filteredAttributes,
      }
    })
    .filter(item => item.attributes.length > 0)
})
</script>
